import { render } from "./App.vue?vue&type=template&id=001c7362"
const script = {}

import "./App.vue?vue&type=style&index=0&id=001c7362&lang=scss"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__